import { render, staticRenderFns } from "./expertDetails.vue?vue&type=template&id=1ffd03de&scoped=true"
import script from "./expertDetails.vue?vue&type=script&lang=js"
export * from "./expertDetails.vue?vue&type=script&lang=js"
import style0 from "./expertDetails.vue?vue&type=style&index=0&id=1ffd03de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd03de",
  null
  
)

export default component.exports